<template>
  <div class="tab-items" :style="{'--color': color}">
    <ul class="tab-list">
      <li v-for="tab in tabItems" :key="tab" class="tab-item" :class="{ activeMain: tab === selectedForMain}">
        <div :class="{active: tab === selected}" class="tab-link second-title" @click="setTab(tab)">{{ tab }}</div>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  props: {
    tabItems: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    selectedForMain: {
      type: String,
      required: false,
    }
  },
  methods: {
    setTab(tab){
      this.$emit('setTab',tab)
    }
  }
}
</script>

<style lang="scss">

.tab-items{
  position: relative;
}
.tab-list{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.tab-item{
  border: 1px solid white;
  padding: 15px;
  border-radius: 25px;
  &:first-child{
    .tab-link{
       &:before{
         display: none;
       }
    }
  }
}
.activeMain{
  border: 1px solid #4745B0;
  .tab-link{
    color: #4745B0 !important;
  }
}
.tab-link{
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  border: 1px solid #44C45F;
  transition: all 0.3s ease 0s;
  z-index: 1;
  color: var(--color);
  @media (max-width: 1366.98px) {
    font-size: 20px!important;
  }
  @media (max-width: 767.98px) {
    font-size: 13px!important;
  }
  &.active{
    z-index: 2;
    &:before{
    }
    &:after{
    }
  }
}

</style>